import React, { ReactElement } from 'react'
import { Box, Flex, Grid, Stack, Text } from '@mindfulchefuk/design-system'
import { GiftCardImage } from '@mindfulchefuk/features/GiftCards/components/GiftCardImage'

export const PurchaseDetails = ({
  amount,
}: {
  amount: string
}): ReactElement => (
  <Grid templateColumns={{ base: '1fr', sm: '1fr 1fr' }} gap={20}>
    <Stack spacing={20}>
      <Flex justify="space-between" align="center">
        <Text variant="body-lg-500-caps">gift card</Text>
        <Text>£{amount}</Text>
      </Flex>
      <Flex justify="space-between" align="center">
        <Text variant="body-lg-500-caps">delivery</Text>
        <Text>Free</Text>
      </Flex>
      <Box borderTopWidth={1} borderColor="aubergine" borderStyle="dashed" />
      <Flex justify="space-between" align="center">
        <Text variant="body-lg-500-caps">total</Text>
        <Text variant="heading-sm">£{amount}</Text>
      </Flex>
    </Stack>
    <GiftCardImage />
  </Grid>
)
